import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
    Box,
    Button,
    Card,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogContent,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    Menu,
    MenuItem,
    Select as MuiSelect,
    Radio,
    RadioGroup,
    Stack,
    TextField,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
// import Link from "@mui/material/Link";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from 'dayjs';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Select, { components } from 'react-select';
import { REQUIRED_RED } from '../../App';
import PostalCode from '../../components/Address/PostalCode';
import { formatPostalCode, preventPhoneInputKeys } from '../../components/FormatNumber/FormatNumber';
import { getCountryMasterListApi } from '../../redux/Account/peronalIfno/action';
import { deleteCustomerVehicle, getCityList, getProvinceList } from '../../redux/Customer/action';
import { createSupplierApi } from '../../redux/Supplier/action';
import { CONTACT_PREFRENCES_SUPPLERS, PAYMENT_TERMS, PHONE_TYPES } from '../../utility/Constant';
import { filterUndefined } from '../../utility/helpers/commonFunction';
import { customStyles, errorCustomStyles, phoneTypeCustomStyles } from '../../utility/SelectDropdown';
import { cleanPhoneNumber, inputFormatPhoneNumber, removeDashFromPhoneNumber } from '../Common/FormatPhoneNumber';
import SuccessMessageModal from '../Common/SuccessMessage';
import AddressSelect from '../Customers/Profile/AddressSelect';
import styles from './NewSupplier.module.css';
import { Add } from '@mui/icons-material';
import AddressAutocomplete from '../Customers/Profile/AddressAutocomplete';

const NewSupplier = () => {
    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }
    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
        getValues,
        setError,
        clearErrors,
        reset,
        setFocus,
    } = useForm({
        defaultValues: {
            phoneNumberType: {
                key: 'mobile',
                value: 'Mobile',
            },
            secondaryPhoneNumberType: {
                key: 'mobile',
                value: 'Mobile',
            },
        },
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showFullScreenLoader, setShowFullScreenLoader] = useState(false);
    const [vehicles, setVehicles] = useState([]);
    const [completeAddress, setCompleteAddress] = useState({});
    const [placeId, setPlaceId] = useState('');
    const [open, setOpen] = React.useState(false);
    const [editVehicle, setEditVehicle] = useState({
        edit: false,
        editIndex: '',
    });
    const [notes, setNotes] = useState([]);
    const [noteError, setNoteError] = useState(false);
    const [newNote, setNewNote] = useState('');

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open1 = Boolean(anchorEl);
    const theme = useTheme();

    const [showNotesUI, setShowNotesUI] = useState(false);
    const [showAdditionalDetailUI, setShowAdditionalDetailUI] = useState(false);

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [selectedActionOfNote, setSelectedActionOfNote] = useState('');
    const [editDeleteNoteId, setEditDeleteNoteId] = useState('');
    const [editNoteText, setEditNoteText] = useState('');
    const [recordFoundByPhone, setRecordFoundByPhone] = useState({
        id: '',
        found: false,
    });
    const [addressValues, setAddressValue] = useState({
        street_number: '',
        city: '',
        province: '',
        postal: '',
        country: '',
        provinceId: '',
        cityId: '',
        streetAddress: '',
    });
    const [cityList, setCityList] = useState([]);
    const [provinceList, setProvinceList] = useState([]);
    const [cityListLoader, setCityListLoader] = useState(false);
    const [provinceListLoader, setProvinceListLoader] = useState(false);
    const [phoneTypes, setPhoneTypes] = useState(PHONE_TYPES);
    const [paymentTermsTypes, setPaymentTermsType] = useState(PAYMENT_TERMS);

    const [selectedPhoneTypes, setSelectedPhoneTypes] = useState({
        primary: 'mobile',
        secondary: 'mobile',
    });

    const [showSecondaryNumber, setShowSecondaryNumber] = useState(false);
    const [showSecondaryEmail, setShowSecondaryEmail] = useState(false);
    const [primaryEmailIndex, setPrimaryEmailIndex] = useState(0);
    const [error, setErrors] = useState({});

    //
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedCountrySecondary, setSelectedCountrySecondary] = useState(null);

    const handleClickNoteActions = (event, data) => {
        setAnchorEl(event.currentTarget);
        setSelectedActionOfNote(data);
    };
    const handleCloseNoteActions = () => {
        setAnchorEl(null);
        setSelectedActionOfNote('');
    };

    const handleDeleteVehicleByAPI = async (id) => {
        setShowLoader(true);
        const resp = await dispatch(deleteCustomerVehicle(id));

        setShowLoader(false);
        return resp;
    };

    const handleAddNote = async () => {
        if (!newNote) {
            return setNoteError(true);
        }
        setNoteError(false);

        setNotes([...notes, { note: newNote, createdAt: new Date() }]);
        setNewNote('');
    };

    const deleteNote = (selectedActionOfNote) => {
        const index = notes.indexOf(selectedActionOfNote);
        notes.splice(index, 1);
    };

    const handleEditNote = () => {
        const allNotes = [...notes];
        let findIndex = allNotes.indexOf(editDeleteNoteId);
        // console.log("findIndex", findIndex);
        let data = { ...allNotes[findIndex], note: editNoteText.trim() };
        allNotes[findIndex] = data;
        // allNotes[0].note="sdsds"
        setNotes(allNotes);
        setSelectedActionOfNote('');
        setEditDeleteNoteId('');
        setEditNoteText('');
    };

    const countryMasterList = useSelector((state) => state.account?.countryMasterList);

    useEffect(() => {
        fetchCityList();
        fetchProvinceList();
        fetchCountryMasterList();
    }, []);

    const fetchCountryMasterList = async () => {
        let resp = await dispatch(getCountryMasterListApi());
        if (resp.length > 0) {
            const selected = resp.find((item) => item.default === true);
            setSelectedCountry(selected);
            setSelectedCountrySecondary(selected);
        }
    };

    const fetchCityList = async (province, country) => {
        setCityListLoader(true);
        let resp = await dispatch(getCityList({ country: '64e738882fec8f2c9b79c139', province: province }));
        if (resp) {
            setCityList(resp);
        }
        setCityListLoader(false);
    };

    const fetchProvinceList = async (country) => {
        setProvinceListLoader(true);
        let resp = await dispatch(getProvinceList({ country: '64e738882fec8f2c9b79c139' }));
        if (resp) {
            setProvinceList(resp);
        }
        setProvinceListLoader(false);
    };

    const onSubmit = async (values) => {
        console.log('🚀 ~ onSubmit ~ values:', values);
        setShowFullScreenLoader(true);
        let payload = { ...values };

        if (!payload.account || payload === '') {
            delete payload.account;
        }

        // Handle address data if present
        if (addressValues?.city) {
            payload.cityId = addressValues?.cityId;
        }
        if (addressValues?.province) {
            payload.provinceId = addressValues?.provinceId;
        }
        // Phone number handling
        payload.phoneNumberType = values?.phoneNumberType?.key;
        payload.phoneNumberCountryId = selectedCountry?._id;

        payload.phoneNumber = cleanPhoneNumber(payload.phoneNumber);

        if (values?.secondaryPhoneNumber && values.secondaryPhoneNumber !== '') {
            payload.secondaryPhoneNumberType = payload.secondaryPhoneNumberType?.key;
            payload.secondaryPhoneNumberCountryId = selectedCountrySecondary?._id;
            payload.secondaryPhoneNumber = cleanPhoneNumber(values.secondaryPhoneNumber);
        } else {
            delete payload.secondaryPhoneNumberType;
        }

        // Email handling based on primaryEmailIndex
        if (primaryEmailIndex === 0) {
            payload.primaryEmail = values.primaryEmail;
            payload.secondaryEmail = values.secondaryEmail || undefined;
        } else if (primaryEmailIndex === 1) {
            payload.primaryEmail = values.secondaryEmail;
            payload.secondaryEmail = values.primaryEmail;
        }

        if (payload.primaryEmail === '') {
            delete payload.primaryEmail;
        }
        if (payload.secondaryEmail === '') {
            delete payload.secondaryEmail;
        }
        if (payload.paymentTerms && payload.paymentTerms.value) {
            payload.paymentTerms = payload.paymentTerms.key;
        }

        //Add Notes
        // payload.notes = [];
        // if (notes?.length > 0) {
        //   notes?.map((note) => {
        //     payload.notes.push({ notes: note?.note });
        //   });
        // }
        if (payload.city) {
            delete payload.city;
        }
        if (payload.province) {
            delete payload.province;
        }
        const resp = await dispatch(createSupplierApi(filterUndefined(payload)));
        if (resp) {
            setShowFullScreenLoader(false);
            navigate(`/suppliers/${resp._id}`);
        } else {
            setShowFullScreenLoader(false);
        }
    };

    const validatePhoneNumber = (number) => {
        const numericValue = number.replace(/\D/g, '');
        return numericValue.length === 10;
    };

    const validate = () => {
        const newErrors = {};
        const isAnyFieldFilled = addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal;

        if (isAnyFieldFilled) {
            if (!addressValues.streetAddress) newErrors.streetAddress = 'Street address is required';
            if (!addressValues.province) newErrors.province = 'Province is required';
            if (!addressValues.city) newErrors.city = 'City is required';
            if (addressValues.postal) {
                const isUSA = selectedCountry?.country === 'United States';
                const isValidLength = isUSA ? addressValues.postal.length === 5 : addressValues.postal.length === 7;

                if (!isValidLength) {
                    const errorMessage = isUSA ? 'Postal code is required - 5 digits' : 'Postal code is required - 6 digits';
                    newErrors.postalCode = { message: errorMessage };
                }
            } else {
                newErrors.postalCode = { message: 'Postal code is required' };
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const Input = ({ ...rest }) => <components.Input {...rest} autoComplete={'nope'} />;

    //Country Selection fucntion
    const handleCountryChange = (event) => {
        const selected = countryMasterList.find((item) => item._id === event.target.value);
        setSelectedCountry(selected);
    };
    //Country Selection fucntion
    const handleCountryChangeSecondary = (event) => {
        const selected = countryMasterList.find((item) => item._id === event.target.value);
        setSelectedCountrySecondary(selected);
    };

    return (
        <>
            <Box padding={'32px 24px'}>
                <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
                    <Grid item lg={12} md={12} sm={12} xs={12} paddingBottom={'8px'}>
                        <div role="presentation" onClick={handleClick}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    to="/suppliers"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Suppliers
                                </Link>
                                <Link
                                    to=""
                                    style={{
                                        color: 'black',
                                        textDecoration: 'none',
                                        opacity: '0.6',
                                    }}
                                >
                                    New Supplier
                                </Link>
                            </Breadcrumbs>
                        </div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} fontWeight={'bold'}>
                        <Typography sx={{ fontSize: '34px', fontWeight: 500 }}>New Supplier</Typography>
                    </Grid>
                </Grid>

                {/* supplier form */}
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* basic details grid  */}
                    <Grid
                        container
                        justifyContent={'start'}
                        boxShadow={3}
                        borderTop={'none'}
                        padding={'24px'}
                        borderRadius={'10px'}
                        marginTop={'32px'}
                        bgcolor={'white'}
                        rowGap={2}
                    >
                        <Grid item xs={12} sm={12} md={3.2} xl={3.2}>
                            <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                Basic Details
                            </Typography>
                        </Grid>
                        <Grid container item xs={12} sm={12} md={8.8} xl={8.8} columnSpacing={3} rowSpacing={2}>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant="body1" className="label-500">
                                    Supplier Name <span style={{ color: REQUIRED_RED }}>*</span>
                                </Typography>
                                <Controller
                                    name="name"
                                    control={control}
                                    rules={{
                                        required: 'Supplier name is required',
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            error={!!errors.name}
                                            helperText={errors.name ? errors.name.message : ''}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant="body1" className="label-500">
                                    Account #
                                </Typography>
                                <Controller
                                    name="account"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            error={!!errors.account}
                                            helperText={errors.account ? errors.account.message : ''}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant="body1" className="label-500">
                                    Contact First Name{' '}
                                </Typography>
                                <Controller
                                    name="contactPerson.firstName"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            error={!!errors.firstName}
                                            helperText={errors.firstName ? errors.firstName.message : ''}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Typography variant="body1" className="label-500">
                                    Contact Last Name{' '}
                                </Typography>
                                <Controller
                                    name="contactPerson.lastName"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            error={!!errors.lastName}
                                            helperText={errors.lastName ? errors.lastName.message : ''}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* phone number  */}
                            <Grid item container xs={12} sm={12} md={12} xl={12} className={styles.cardDetails}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography variant="body1" className="label-500">
                                        {' '}
                                        Primary Phone Number <span style={{ color: REQUIRED_RED }}>*</span>
                                    </Typography>
                                    <div style={{ display: 'flex' }}>
                                        <Grid container spacing={2} rowGap={2}>
                                            <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
                                                <FormControl fullWidth error={!!errors.phoneNumberType}>
                                                    <Controller
                                                        name="phoneNumberType"
                                                        control={control}
                                                        rules={{
                                                            required: 'Phone Number Type is required',
                                                        }}
                                                        render={({ field }) => (
                                                            <Select
                                                                placeholder=""
                                                                isDisabled={false}
                                                                isLoading={false}
                                                                isClearable={false}
                                                                isSearchable={false}
                                                                value={
                                                                    selectedPhoneTypes
                                                                        ? phoneTypes.find((option) => option.key === selectedPhoneTypes?.primary)
                                                                        : ''
                                                                }
                                                                options={phoneTypes ? phoneTypes : []}
                                                                getOptionLabel={(option) => option.value} // Specifies which field to use as the label
                                                                getOptionValue={(option) => option}
                                                                onChan={(e) => {
                                                                    setSelectedPhoneTypes({
                                                                        ...selectedPhoneTypes,
                                                                        primary: e ? e.key : '',
                                                                    });
                                                                }}
                                                                styles={
                                                                    errors.primaryPhoneNumberType
                                                                        ? {
                                                                              ...customStyles,
                                                                              ...errorCustomStyles,
                                                                              ...phoneTypeCustomStyles,
                                                                          }
                                                                        : {
                                                                              ...customStyles,
                                                                              ...phoneTypeCustomStyles,
                                                                          }
                                                                }
                                                                error={!!errors.primaryPhoneNumberType}
                                                                helperText={errors.primaryPhoneNumberType ? errors.primaryPhoneNumberType.message : ''}
                                                                {...field}
                                                                components={{ Input }}
                                                            />
                                                        )}
                                                    />
                                                    {errors.phoneNumberType && <FormHelperText>{errors.phoneNumberType.message}</FormHelperText>}
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} sm={8} md={8} lg={10} xl={10}>
                                                <Controller
                                                    name="phoneNumber"
                                                    control={control}
                                                    rules={{
                                                        required: 'Phone Number is required',
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <MuiSelect
                                                                        style={{
                                                                            width: '92px',
                                                                            minWidth: '92px',
                                                                            height: '56px',
                                                                            border: 'none',
                                                                            marginRight: '16.5px',
                                                                        }}
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                style: {
                                                                                    width: '264px',
                                                                                    marginLeft: '86px',
                                                                                    boxShadow:
                                                                                        'box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                                                                },
                                                                            },
                                                                            MenuListProps: {
                                                                                style: {},
                                                                            },
                                                                        }}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                border: 'none',
                                                                            },
                                                                            '& .MuiOutlinedInput-root': {
                                                                                borderTopRightRadius: '0px',
                                                                                borderBottomRightRadius: '0px',
                                                                            },
                                                                            borderTopRightRadius: '0px',
                                                                            borderBottomRightRadius: '0px',
                                                                            background: '#F1F1F1',
                                                                        }}
                                                                        value={selectedCountry?._id ?? ''}
                                                                        onChange={handleCountryChange}
                                                                        renderValue={(selected) => {
                                                                            const country =
                                                                                countryMasterList.find((item) => item._id === selected) || selectedCountry;
                                                                            if (!country) return 'Select';
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                    }}
                                                                                >
                                                                                    <span style={{ marginRight: '8px' }}>{country.flag}</span>
                                                                                    {country.dial_code}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        IconComponent={KeyboardArrowDownIcon} // Use custom icon
                                                                    >
                                                                        {countryMasterList?.length > 0 &&
                                                                            countryMasterList.map((country) => (
                                                                                <MenuItem key={country._id} value={country._id} style={{ height: '44px' }}>
                                                                                    <span style={{ marginRight: '8px' }}>{country.flag}</span>
                                                                                    {country.country} ({country.dial_code})
                                                                                </MenuItem>
                                                                            ))}
                                                                    </MuiSelect>
                                                                ),
                                                            }}
                                                            id="outlined-basic"
                                                            sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                    paddingLeft: '0',
                                                                },
                                                            }}
                                                            variant="outlined"
                                                            fullWidth
                                                            error={!!errors.phoneNumber}
                                                            helperText={errors.phoneNumber ? errors.phoneNumber.message : ''}
                                                            {...field}
                                                            onChange={(e) => {
                                                                if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                                                    const input = e.target;
                                                                    const rawValue = e.target.value;
                                                                    // Store previous cursor position
                                                                    const prevCursorPosition = input.selectionStart;
                                                                    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                                                    // Count hyphens before formatting
                                                                    const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                                                    // Format the input value
                                                                    const formattedValue = inputFormatPhoneNumber(rawValue);

                                                                    // Count hyphens after formatting
                                                                    const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;

                                                                    let newCursorPosition = prevCursorPosition;

                                                                    if (isDeleting) {
                                                                        // If a hyphen was removed, move cursor back by 1
                                                                        if (hyphenCountAfter < hyphenCountBefore) {
                                                                            newCursorPosition--;
                                                                        }
                                                                    } else {
                                                                        // If a hyphen was added, move cursor forward by 1
                                                                        if (hyphenCountAfter > hyphenCountBefore) {
                                                                            newCursorPosition++;
                                                                        }
                                                                    }
                                                                    // Ensure cursor position doesn't go out of bounds
                                                                    newCursorPosition = Math.max(0, Math.min(newCursorPosition, formattedValue.length));
                                                                    // Update the state
                                                                    setValue('phoneNumber', formattedValue);

                                                                    // Restore the adjusted cursor position
                                                                    setTimeout(() => {
                                                                        input.setSelectionRange(newCursorPosition, newCursorPosition);
                                                                    }, 0);
                                                                    let nondashedPhoneNumber = e.target.value.toString()?.replace(/-/g, '');
                                                                    if (
                                                                        nondashedPhoneNumber.length == 10 &&
                                                                        validatePhoneNumber(inputFormatPhoneNumber(e.target.value))
                                                                    ) {
                                                                    }

                                                                    if (removeDashFromPhoneNumber(e.target.value).length < 10) {
                                                                        setError('phoneNumber', {
                                                                            message: 'Phone Number should be 10 digits',
                                                                        });
                                                                    } else clearErrors('phoneNumber');
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                preventPhoneInputKeys(e);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </div>
                                    {!showSecondaryNumber && (
                                        <div
                                            onClick={() => setShowSecondaryNumber(true)}
                                            style={{
                                                color: '#006CDD',
                                                cursor: 'pointer',
                                                fontWeight: 500,
                                                height: '36px',
                                                padding: '4px 5px',
                                                letterSpacing: '0.46px',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            + ADD SECONDARY NUMBER
                                        </div>
                                    )}
                                </Grid>
                            </Grid>
                            {showSecondaryNumber && (
                                <Grid item container xs={12} sm={12} md={12} xl={12}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Typography variant="body1" className="label-500">
                                            Secondary Phone Number{' '}
                                        </Typography>

                                        <Grid container item spacing={2} rowGap={2}>
                                            <Grid item xs={12} sm={4} md={4} lg={2} xl={2}>
                                                <FormControl fullWidth error={!!errors.secondaryPhoneNumberType}>
                                                    <Controller
                                                        name="secondaryPhoneNumberType"
                                                        control={control}
                                                        // rules={{
                                                        //   required: "Phone Number Type is required",
                                                        // }}
                                                        render={({ field }) => (
                                                            <Select
                                                                placeholder="" // defaultValue={}
                                                                isDisabled={false}
                                                                isLoading={false}
                                                                isClearable={false}
                                                                isSearchable={false}
                                                                value={
                                                                    selectedPhoneTypes
                                                                        ? phoneTypes.find((option) => option.key === selectedPhoneTypes?.primary)
                                                                        : ''
                                                                }
                                                                options={phoneTypes ? phoneTypes : []}
                                                                getOptionLabel={(option) => option.value} // Specifies which field to use as the label
                                                                getOptionValue={(option) => option}
                                                                onChange={(e) => {
                                                                    setSelectedPhoneTypes({
                                                                        ...selectedPhoneTypes,
                                                                        secondary: e ? e.key : '',
                                                                    });
                                                                }}
                                                                styles={
                                                                    errors.secondaryPhoneNumberType
                                                                        ? {
                                                                              ...customStyles,
                                                                              ...errorCustomStyles,
                                                                              ...phoneTypeCustomStyles,
                                                                          }
                                                                        : {
                                                                              ...customStyles,
                                                                              ...phoneTypeCustomStyles,
                                                                          }
                                                                }
                                                                error={!!errors.secondaryPhoneNumberType}
                                                                helperText={errors.secondaryPhoneNumberType ? errors.secondaryPhoneNumberType.message : ''}
                                                                {...field}
                                                                components={{ Input }}
                                                            />
                                                        )}
                                                    />
                                                    {errors.secondaryPhoneNumberType && (
                                                        <FormHelperText>{errors.secondaryPhoneNumberType.message}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={10} sm={7.2} md={7.5} lg={9.5} xl={9.5}>
                                                <Controller
                                                    name="secondaryPhoneNumber"
                                                    control={control}
                                                    render={({ field }) => (
                                                        <TextField
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <MuiSelect
                                                                        style={{
                                                                            width: '92px',
                                                                            minWidth: '92px',
                                                                            height: '56px',
                                                                            border: 'none',
                                                                            marginRight: '16.5px',
                                                                        }}
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                style: {
                                                                                    width: '264px',
                                                                                    marginLeft: '86px',
                                                                                    boxShadow:
                                                                                        'box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                                                                },
                                                                            },
                                                                            MenuListProps: {
                                                                                style: {},
                                                                            },
                                                                        }}
                                                                        sx={{
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                borderRight: 'none',
                                                                            },
                                                                            '& .MuiOutlinedInput-root': {
                                                                                borderTopRightRadius: '0px',
                                                                                borderBottomRightRadius: '0px',
                                                                            },
                                                                            borderTopRightRadius: '0px',
                                                                            borderBottomRightRadius: '0px',
                                                                            background: '#F1F1F1',
                                                                        }}
                                                                        value={selectedCountrySecondary?._id ?? ''}
                                                                        onChange={handleCountryChangeSecondary}
                                                                        renderValue={(selected) => {
                                                                            const country =
                                                                                countryMasterList.find((item) => item._id === selected) ||
                                                                                selectedCountrySecondary;
                                                                            if (!country) return 'Select';
                                                                            return (
                                                                                <div
                                                                                    style={{
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                    }}
                                                                                >
                                                                                    <span style={{ marginRight: '8px' }}>{country.flag}</span>
                                                                                    {country.dial_code}
                                                                                </div>
                                                                            );
                                                                        }}
                                                                        IconComponent={KeyboardArrowDownIcon}
                                                                    >
                                                                        {countryMasterList?.length > 0 &&
                                                                            countryMasterList.map((country) => (
                                                                                <MenuItem key={country._id} value={country._id} style={{ height: '44px' }}>
                                                                                    <span style={{ marginRight: '8px' }}>{country.flag}</span>
                                                                                    {country.country} ({country.dial_code})
                                                                                </MenuItem>
                                                                            ))}
                                                                    </MuiSelect>
                                                                ),
                                                            }}
                                                            id="outlined-basic"
                                                            sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                    paddingLeft: '0',
                                                                },
                                                            }}
                                                            variant="outlined"
                                                            fullWidth
                                                            // required
                                                            error={!!errors.secondaryPhoneNumber}
                                                            helperText={errors.secondaryPhoneNumber ? errors.secondaryPhoneNumber.message : ''}
                                                            {...field}
                                                            onChange={(e) => {
                                                                if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                                                    const input = e.target;
                                                                    const rawValue = e.target.value;
                                                                    // Store previous cursor position
                                                                    const prevCursorPosition = input.selectionStart;
                                                                    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                                                    // Count hyphens before formatting
                                                                    const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                                                    // Format the input value
                                                                    const formattedValue = inputFormatPhoneNumber(rawValue);

                                                                    // Count hyphens after formatting
                                                                    const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;

                                                                    let newCursorPosition = prevCursorPosition;

                                                                    if (isDeleting) {
                                                                        // If a hyphen was removed, move cursor back by 1
                                                                        if (hyphenCountAfter < hyphenCountBefore) {
                                                                            newCursorPosition--;
                                                                        }
                                                                    } else {
                                                                        // If a hyphen was added, move cursor forward by 1
                                                                        if (hyphenCountAfter > hyphenCountBefore) {
                                                                            newCursorPosition++;
                                                                        }
                                                                    }
                                                                    // Ensure cursor position doesn't go out of bounds
                                                                    newCursorPosition = Math.max(0, Math.min(newCursorPosition, formattedValue.length));
                                                                    // Update the state
                                                                    setValue('secondaryPhoneNumber', formattedValue);

                                                                    // Restore the adjusted cursor position
                                                                    setTimeout(() => {
                                                                        input.setSelectionRange(newCursorPosition, newCursorPosition);
                                                                    }, 0);

                                                                    if (removeDashFromPhoneNumber(e.target.value).length < 10) {
                                                                        setError('secondaryPhoneNumber', {
                                                                            message: 'Phone Number should be 10 digits',
                                                                        });
                                                                    } else clearErrors('secondaryPhoneNumber');
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                preventPhoneInputKeys(e);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={2} sm={0.8} md={0.5} xl={0.5}>
                                                <div
                                                    style={{
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <IconButton
                                                        color="error"
                                                        size="medium"
                                                        onClick={() => {
                                                            setShowSecondaryNumber(false);
                                                            setValue('secondaryPhoneNumber', undefined);
                                                            setValue('secondaryPhoneNumberType', undefined);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}

                            {/* Email  */}
                            <Grid item container>
                                <Grid item xs={12}>
                                    <Typography variant="body1" className="label-500">
                                        Email
                                    </Typography>
                                    <div style={{ display: 'flex', gap: '24px' }}>
                                        <Grid item xs={12}>
                                            {/* Primary Email */}
                                            <Grid item xs={12}>
                                                <Controller
                                                    name="primaryEmail"
                                                    control={control}
                                                    rules={{
                                                        pattern: {
                                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                            message: 'Please enter a valid email address',
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            variant="outlined"
                                                            fullWidth
                                                            error={!!errors.primaryEmail}
                                                            helperText={errors.primaryEmail ? errors.primaryEmail.message : ''}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <div
                                                    style={{
                                                        height: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={primaryEmailIndex === 0}
                                                                onChange={(e) => {
                                                                    showSecondaryEmail && setPrimaryEmailIndex(e.target.checked ? 0 : 1);
                                                                }}
                                                            />
                                                        }
                                                        label="Primary"
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>

                                        {/* Secondary Email */}
                                        <Grid item xs={12}>
                                            {showSecondaryEmail ? (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Controller
                                                            name="secondaryEmail"
                                                            control={control}
                                                            rules={{
                                                                pattern: {
                                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                                    message: 'Please enter a valid email address',
                                                                },
                                                            }}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    error={!!errors.secondaryEmail}
                                                                    helperText={errors.secondaryEmail ? errors.secondaryEmail.message : ''}
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <div
                                                            style={{
                                                                height: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={primaryEmailIndex === 1}
                                                                        onChange={(e) => {
                                                                            setPrimaryEmailIndex(e.target.checked ? 1 : 0);
                                                                        }}
                                                                    />
                                                                }
                                                                label="Primary"
                                                            />
                                                            <IconButton
                                                                color="error"
                                                                size="medium"
                                                                onClick={() => {
                                                                    setShowSecondaryEmail(false);
                                                                    setPrimaryEmailIndex(0);
                                                                    setShowSecondaryNumber(false);
                                                                    setValue('secondaryEmail', undefined);
                                                                }}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </div>
                                                    </Grid>
                                                </>
                                            ) : (
                                                <div
                                                    onClick={() => setShowSecondaryEmail(true)}
                                                    style={{
                                                        color: '#006CDD',
                                                        cursor: 'pointer',
                                                        fontWeight: 500,
                                                        padding: '4px 5px',
                                                        fontSize: '14px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    + ADD EMAIL
                                                </div>
                                            )}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>

                            {/* website  */}
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography variant="body1" className="label-500">
                                    Website
                                </Typography>
                                <Controller
                                    name="website"
                                    control={control}
                                    rules={{
                                        validate: (value) => (value ? /^https:\/\/.+$/.test(value) || 'Invalid URL' : true),
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            id="outlined-basic"
                                            variant="outlined"
                                            fullWidth
                                            error={!!errors.website}
                                            helperText={errors.website ? errors.website.message : ''}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* contact Preferences  */}
                            <Grid item xs={12} sm={12} md={12}>
                                <FormControl fullWidth error={!!errors.contactPreference}>
                                    <Typography variant="body1" className="label-500">
                                        Contact Preferences
                                    </Typography>
                                    <Controller
                                        name="contactPreference"
                                        control={control}
                                        render={({ field: { onChange, value } }) => (
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                onChange={(e) => {
                                                    onChange(e);
                                                }}
                                            >
                                                {CONTACT_PREFRENCES_SUPPLERS.map((contact) => (
                                                    <FormControlLabel value={contact.key} control={<Radio />} label={contact?.value} />
                                                ))}
                                            </RadioGroup>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Address  */}
                    {showAdditionalDetailUI && (
                        <Grid
                            container
                            sx={{ boxShadow: 3 }}
                            justifyContent={'start'}
                            borderTop={'none'}
                            padding={'24px'}
                            borderRadius={'10px'}
                            marginTop={'32px'}
                            bgcolor={'white'}
                            rowGap={2}
                        >
                            <Grid item xs={12} sm={12} md={3.2} xl={3.2}>
                                <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                    Address
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={8.8} xl={8.8} rowGap={2} justifyContent={'space-between'}>
                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                    <Typography variant="body1" className="label-500">
                                        {' '}
                                        Street Address
                                        {(addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal) && (
                                            <span style={{ color: '#D32F2F' }}> *</span>
                                        )}
                                    </Typography>
                                    <Controller
                                        name="streetAddress"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                id="outlined-basic"
                                                variant="outlined"
                                                fullWidth
                                                error={!!error.streetAddress}
                                                helperText={error.streetAddress ? error.streetAddress : ''}
                                                {...field}
                                                onChange={(e) => {
                                                    setValue('streetAddress', e.target.value);
                                                    setAddressValue({
                                                        ...addressValues,
                                                        streetAddress: e.target.value,
                                                    });
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid container item xs={12} sm={12} md={12} xl={12} spacing={2}>
                                    <Grid item xs={12} sm={4} md={4} xl={4}>
                                        <Typography variant="body1" className="label-500">
                                            {' '}
                                            City
                                            {(addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal) && (
                                                <span style={{ color: '#D32F2F' }}> *</span>
                                            )}
                                        </Typography>
                                        <Controller
                                            name="cityId"
                                            control={control}
                                            render={({ field }) => (
                                                <AddressAutocomplete
                                                    list={cityList}
                                                    addressValues={addressValues}
                                                    value={getValues().city}
                                                    setAddressValue={setAddressValue}
                                                    type={'city'}
                                                    loader={cityListLoader}
                                                    setValue={setValue}
                                                    error={!!errors.city}
                                                    clearInput={!addressValues.provinceId}
                                                />
                                            )}
                                        />
                                        {error && error.city && (
                                            <p
                                                style={{
                                                    color: '#d32f2f',
                                                    fontSize: '0.75rem',
                                                    letterSpacing: '0.03333em',
                                                    lineHeight: '1.66',
                                                    marginTop: '3px',
                                                }}
                                            >
                                                {error.city}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4} xl={4}>
                                        <Typography variant="body1" className="label-500">
                                            {' '}
                                            Province
                                            {(addressValues.streetAddress || addressValues.province || addressValues.city || addressValues.postal) && (
                                                <span style={{ color: '#D32F2F' }}> *</span>
                                            )}
                                        </Typography>

                                        <Controller
                                            name="provinceId"
                                            control={control}
                                            render={({ field }) => (
                                                <AddressAutocomplete
                                                    list={provinceList}
                                                    value={getValues().province}
                                                    addressValues={addressValues}
                                                    setAddressValue={setAddressValue}
                                                    type={'province'}
                                                    setCityList={setCityList}
                                                    fetchCityList={fetchCityList}
                                                    loader={provinceListLoader}
                                                    setValue={setValue}
                                                    error={!!errors.province}
                                                />
                                            )}
                                        />

                                        {error && error.province && (
                                            <p
                                                style={{
                                                    color: '#d32f2f',
                                                    fontSize: '0.75rem',
                                                    letterSpacing: '0.03333em',
                                                    lineHeight: '1.66',
                                                    marginTop: '3px',
                                                }}
                                            >
                                                {error.province}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={4} md={4} xl={4}>
                                        <PostalCode
                                            name="postalCode"
                                            control={control}
                                            errors={error}
                                            setValueinForm={setValue}
                                            setAddressValue={setAddressValue}
                                            addressValues={addressValues}
                                            selectedCountry={selectedCountry}
                                            spacing={0.5}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}

                    {/* payment terms grid  */}
                    <Grid
                        container
                        sx={{ boxShadow: 3 }}
                        justifyContent={'start'}
                        borderTop={'none'}
                        padding={'24px'}
                        borderRadius={'10px'}
                        marginTop={'32px'}
                        bgcolor={'white'}
                        rowGap={2}
                    >
                        <Grid item xs={12} sm={12} md={3.2} xl={3.2}>
                            <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                Payment Terms
                            </Typography>
                        </Grid>
                        <Grid container item xs={12} sm={12} md={8.8} xl={8.8} rowGap={2}>
                            <Grid container item xs={12} sm={12} md={5} xl={5}>
                                <FormControl fullWidth error={!!errors.paymentTerms}>
                                    <Controller
                                        name="paymentTerms"
                                        control={control}
                                        render={({ field }) => (
                                            <Select
                                                placeholder="" // defaultValue={}
                                                isDisabled={false}
                                                isLoading={false}
                                                isClearable={false}
                                                isSearchable={false}
                                                options={paymentTermsTypes ? paymentTermsTypes : []}
                                                getOptionLabel={(option) => option.value} // Specifies which field to use as the label
                                                getOptionValue={(option) => option}
                                                styles={
                                                    errors.paymentTerms
                                                        ? {
                                                              ...customStyles,
                                                              ...errorCustomStyles,
                                                              ...phoneTypeCustomStyles,
                                                          }
                                                        : {
                                                              ...customStyles,
                                                              ...phoneTypeCustomStyles,
                                                          }
                                                }
                                                error={!!errors.paymentTerms}
                                                helperText={errors.paymentTerms ? errors.paymentTerms.message : ''}
                                                {...field}
                                                components={{ Input }}
                                            />
                                        )}
                                    />
                                    {errors.paymentTerms && <FormHelperText>{errors.paymentTerms.message}</FormHelperText>}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* notes grid  */}
                    {showNotesUI && (
                        <Grid
                            container
                            sx={{ boxShadow: 3 }}
                            justifyContent={'start'}
                            borderTop={'none'}
                            padding={'24px'}
                            borderRadius={'10px'}
                            marginTop={'32px'}
                            bgcolor={'white'}
                            rowGap={2}
                        >
                            <Grid item xs={12} sm={12} md={3.2} xl={3.2}>
                                <Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px' }}>
                                    Notes
                                </Typography>
                            </Grid>
                            <Grid container item xs={12} sm={12} md={8.8} xl={8.8} rowGap={2}>
                                <Grid item xs={12} sm={12} md={12} xl={12}>
                                    <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '20px' }}>
                                        Recent Notes
                                    </Typography>
                                </Grid>
                                <Grid container item xs={12} sm={12} md={12} xl={12}>
                                    <TextField id="outlined-basic" variant="outlined" fullWidth onChange={(e) => setNewNote(e.target.value)} value={newNote} />
                                    {noteError && (
                                        <span
                                            style={{
                                                color: 'rgb(211, 47, 47)',
                                                fontSize: 12,
                                                fontWeight: 400,
                                                lineHeight: '20px',
                                                marginTop: '3px',
                                            }}
                                        >
                                            Please enter note
                                        </span>
                                    )}
                                </Grid>

                                <Grid container item xs={12} sm={12} md={12} xl={12} justifyContent={'end'} marginTop={'0px'}>
                                    <Grid item padding={'0 0 26px 0'}>
                                        <Button variant="contained" size="large" style={{ background: '#002394' }} onClick={handleAddNote}>
                                            Add Note
                                        </Button>
                                    </Grid>
                                </Grid>

                                {notes?.map((data, index) => {
                                    return (
                                        <Grid
                                            container
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            xl={12}
                                            style={{
                                                backgroundColor: '#e6f7f7',
                                                borderRadius: '8px',
                                            }}
                                            padding={'16px'}
                                            display={'block'}
                                        >
                                            <Stack direction={'row'} justifyContent={'space-between'} mb={2}>
                                                <div>
                                                    <Typography variant="body1">
                                                        {dayjs(data?.createdAt).format('MMMM DD, YYYY') + ' at ' + dayjs(data?.createdAt).format('hh:mm A')}
                                                    </Typography>
                                                </div>

                                                <div style={{ marginRight: '16px' }}>
                                                    <Button
                                                        variant="contained"
                                                        onClick={(e) => handleClickNoteActions(e, data)}
                                                        id="demo-positioned-button"
                                                        aria-controls={open1 ? 'demo-positioned-menu' : undefined}
                                                        aria-haspopup="true"
                                                        aria-expanded={open1 ? 'true' : undefined}
                                                        endIcon={<ExpandMoreIcon />}
                                                    >
                                                        Actions
                                                    </Button>
                                                    <Menu
                                                        style={{ width: '300px' }}
                                                        id="demo-positioned-menu"
                                                        aria-labelledby="demo-positioned-button"
                                                        anchorEl={anchorEl}
                                                        open={open1}
                                                        onClose={handleCloseNoteActions}
                                                        anchorOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        }}
                                                    >
                                                        <MenuItem
                                                            onClick={() => {
                                                                handleCloseNoteActions();
                                                                setEditDeleteNoteId(selectedActionOfNote);
                                                                setEditNoteText(selectedActionOfNote?.note);
                                                            }}
                                                        >
                                                            {' '}
                                                            <EditIcon style={{ marginRight: '10px' }} /> Edit Note
                                                        </MenuItem>
                                                        <MenuItem
                                                            onClick={() => {
                                                                handleCloseNoteActions();
                                                                deleteNote(selectedActionOfNote);
                                                            }}
                                                        >
                                                            {' '}
                                                            <DeleteIcon style={{ marginRight: '10px' }} /> Delete Note
                                                        </MenuItem>
                                                    </Menu>
                                                </div>
                                            </Stack>

                                            {editDeleteNoteId && notes.indexOf(editDeleteNoteId) == index ? (
                                                <>
                                                    <TextField
                                                        style={{
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #C4C4C4',
                                                            width: '100%',
                                                        }}
                                                        value={editNoteText}
                                                        onChange={(e) => setEditNoteText(e.target.value)}
                                                    />
                                                    <Stack direction={'row'} mb={2} mt={2} spacing={2} sx={{ marginBottom: '0px' }}>
                                                        <div>
                                                            <Button
                                                                variant="contained"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleEditNote();
                                                                }}
                                                                disabled={editNoteText?.trim() == ''}
                                                            >
                                                                SAVE
                                                            </Button>
                                                        </div>
                                                        <div>
                                                            <Button
                                                                variant="outlined"
                                                                onClick={() => {
                                                                    setEditDeleteNoteId('');
                                                                    setSelectedActionOfNote('');
                                                                }}
                                                            >
                                                                CANCEL
                                                            </Button>
                                                        </div>
                                                    </Stack>
                                                </>
                                            ) : (
                                                <Card
                                                    style={{
                                                        backgroundColor: '#fff',
                                                        padding: '10px',
                                                        border: '1px solid #C4C4C4',
                                                    }}
                                                >
                                                    <Typography variant="body1" sx={{ fontWeight: 400, fontSize: '16px' }}>
                                                        {data?.note}
                                                    </Typography>
                                                </Card>
                                            )}
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Grid>
                    )}

                    {/* save button grid */}
                    <Grid
                        container
                        justifyContent={'end'}
                        marginTop={'32px'}
                        boxShadow={3}
                        borderRadius={'10px'}
                        bgcolor={'white'}
                        padding={'24px'}
                        p={3}
                        gap={3}
                    >
                        {!showAdditionalDetailUI && (
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<Add />}
                                    size="large"
                                    onClick={(e) => {
                                        setShowAdditionalDetailUI(true);
                                    }}
                                >
                                    Add Additional Details
                                </Button>
                            </Grid>
                        )}
                        {!showNotesUI && (
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="large"
                                    startIcon={<Add />}
                                    onClick={(e) => {
                                        setShowNotesUI(true);
                                    }}
                                >
                                    Add Note
                                </Button>
                            </Grid>
                        )}
                        <Grid item>
                            <Button
                                variant="contained"
                                color="secondary"
                                size="large"
                                type="submit"
                                onClick={(e) => {
                                    if (validate()) {
                                        control.handleSubmit(onSubmit);
                                    } else {
                                        e.preventDefault();
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Box>

            {/* EDIt TIMES MODAL  */}
            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
            <Dialog fullScreen={false} open={showFullScreenLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default NewSupplier;
